var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkingMonitoringLeftMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8323_7733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22088 12.3834C10.5189 12.3834 12.3818 10.5205 12.3818 8.22247C12.3818 5.92444 10.5189 4.06152 8.22088 4.06152C5.92285 4.06152 4.05994 5.92444 4.05994 8.22247C4.05994 10.5205 5.92285 12.3834 8.22088 12.3834Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46008 2.41748L5.27557 5.25788",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88655 2.66739C2.34065 2.66739 2.70878 2.29927 2.70878 1.84517C2.70878 1.39107 2.34065 1.02295 1.88655 1.02295C1.43245 1.02295 1.06433 1.39107 1.06433 1.84517C1.06433 2.29927 1.43245 2.66739 1.88655 2.66739Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27353 4.56101L4.97791 3.26539L5.82504 2.41825L5.30181 1.89502",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72811 2.14396C5.18221 2.14396 5.55033 1.77583 5.55033 1.32173C5.55033 0.867633 5.18221 0.499512 4.72811 0.499512C4.27401 0.499512 3.90588 0.867633 3.90588 1.32173C3.90588 1.77583 4.27401 2.14396 4.72811 2.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50081 6.22968L3.25501 4.98389L2.40788 5.83102L1.88464 5.30779",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31185 5.55704C1.76595 5.55704 2.13407 5.18892 2.13407 4.73482C2.13407 4.28072 1.76595 3.9126 1.31185 3.9126C0.857746 3.9126 0.489624 4.28072 0.489624 4.73482C0.489624 5.18892 0.857746 5.55704 1.31185 5.55704Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46008 2.41748L5.27557 5.25788",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88655 2.66739C2.34065 2.66739 2.70878 2.29927 2.70878 1.84517C2.70878 1.39107 2.34065 1.02295 1.88655 1.02295C1.43245 1.02295 1.06433 1.39107 1.06433 1.84517C1.06433 2.29927 1.43245 2.66739 1.88655 2.66739Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27353 4.56101L4.97791 3.26539L5.82504 2.41825L5.30181 1.89502",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72811 2.14396C5.18221 2.14396 5.55033 1.77583 5.55033 1.32173C5.55033 0.867633 5.18221 0.499512 4.72811 0.499512C4.27401 0.499512 3.90588 0.867633 3.90588 1.32173C3.90588 1.77583 4.27401 2.14396 4.72811 2.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50081 6.22968L3.25501 4.98389L2.40788 5.83102L1.88464 5.30779",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31185 5.55704C1.76595 5.55704 2.13407 5.18892 2.13407 4.73482C2.13407 4.28072 1.76595 3.9126 1.31185 3.9126C0.857746 3.9126 0.489624 4.28072 0.489624 4.73482C0.489624 5.18892 0.857746 5.55704 1.31185 5.55704Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9739 14.0274L11.1584 11.187",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5466 15.4228C15.0007 15.4228 15.3688 15.0546 15.3688 14.6005C15.3688 14.1464 15.0007 13.7783 14.5466 13.7783C14.0925 13.7783 13.7244 14.1464 13.7244 14.6005C13.7244 15.0546 14.0925 15.4228 14.5466 15.4228Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1866 11.9092L11.4574 13.1799L10.6102 14.027L11.1334 14.5503",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7059 15.9457C12.16 15.9457 12.5281 15.5776 12.5281 15.1235C12.5281 14.6694 12.16 14.3013 11.7059 14.3013C11.2518 14.3013 10.8837 14.6694 10.8837 15.1235C10.8837 15.5776 11.2518 15.9457 11.7059 15.9457Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9054 10.1895L13.1761 11.4602L14.0232 10.613L14.5465 11.1363",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.12 12.5312C15.5741 12.5312 15.9422 12.163 15.9422 11.7089C15.9422 11.2548 15.5741 10.8867 15.12 10.8867C14.6659 10.8867 14.2977 11.2548 14.2977 11.7089C14.2977 12.163 14.6659 12.5312 15.12 12.5312Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0253 2.46777L11.1849 5.28326",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5983 2.7172C15.0524 2.7172 15.4206 2.34908 15.4206 1.89498C15.4206 1.44088 15.0524 1.07275 14.5983 1.07275C14.1442 1.07275 13.7761 1.44088 13.7761 1.89498C13.7761 2.34908 14.1442 2.7172 14.5983 2.7172Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8837 6.27951L13.1793 4.98389L14.0264 5.83102L14.5497 5.30779",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1234 5.55704C15.5775 5.55704 15.9456 5.18892 15.9456 4.73482C15.9456 4.28072 15.5775 3.9126 15.1234 3.9126C14.6693 3.9126 14.3011 4.28072 14.3011 4.73482C14.3011 5.18892 14.6693 5.55704 15.1234 5.55704Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2131 4.51118L11.4589 3.26539L10.6118 2.41825L11.135 1.89502",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7081 2.14396C12.1622 2.14396 12.5303 1.77583 12.5303 1.32173C12.5303 0.867633 12.1622 0.499512 11.7081 0.499512C11.254 0.499512 10.8859 0.867633 10.8859 1.32173C10.8859 1.77583 11.254 2.14396 11.7081 2.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0253 2.46777L11.1849 5.28326",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5983 2.7172C15.0524 2.7172 15.4206 2.34908 15.4206 1.89498C15.4206 1.44088 15.0524 1.07275 14.5983 1.07275C14.1442 1.07275 13.7761 1.44088 13.7761 1.89498C13.7761 2.34908 14.1442 2.7172 14.5983 2.7172Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8837 6.27951L13.1793 4.98389L14.0264 5.83102L14.5497 5.30779",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1234 5.55704C15.5775 5.55704 15.9456 5.18892 15.9456 4.73482C15.9456 4.28072 15.5775 3.9126 15.1234 3.9126C14.6693 3.9126 14.3011 4.28072 14.3011 4.73482C14.3011 5.18892 14.6693 5.55704 15.1234 5.55704Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2131 4.51118L11.4589 3.26539L10.6118 2.41825L11.135 1.89502",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7081 2.14396C12.1622 2.14396 12.5303 1.77583 12.5303 1.32173C12.5303 0.867633 12.1622 0.499512 11.7081 0.499512C11.254 0.499512 10.8859 0.867633 10.8859 1.32173C10.8859 1.77583 11.254 2.14396 11.7081 2.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4115 13.9776L5.2519 11.1621",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8387 15.373C2.2928 15.373 2.66092 15.0048 2.66092 14.5507C2.66092 14.0966 2.2928 13.7285 1.8387 13.7285C1.3846 13.7285 1.01648 14.0966 1.01648 14.5507C1.01648 15.0048 1.3846 15.373 1.8387 15.373Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52743 10.1895L3.25672 11.4602L2.40958 10.613L1.88635 11.1363",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31356 12.5312C1.76766 12.5312 2.13578 12.163 2.13578 11.7089C2.13578 11.2548 1.76766 10.8867 1.31356 10.8867C0.859455 10.8867 0.491333 11.2548 0.491333 11.7089C0.491333 12.163 0.859455 12.5312 1.31356 12.5312Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25032 11.9092L4.97961 13.1799L5.82675 14.027L5.30352 14.5503",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72982 15.9457C5.18392 15.9457 5.55204 15.5776 5.55204 15.1235C5.55204 14.6694 5.18392 14.3013 4.72982 14.3013C4.27571 14.3013 3.90759 14.6694 3.90759 15.1235C3.90759 15.5776 4.27571 15.9457 4.72982 15.9457Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22037 9.41877C8.88088 9.41877 9.41633 8.88333 9.41633 8.22281C9.41633 7.5623 8.88088 7.02686 8.22037 7.02686C7.55986 7.02686 7.02441 7.5623 7.02441 8.22281C7.02441 8.88333 7.55986 9.41877 8.22037 9.41877Z",
    stroke: "#BD1D23",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9863 8.84558C10.9115 9.16949 10.7869 9.46848 10.6125 9.74255C10.3135 9.61797 10.0146 9.64289 9.84014 9.8173C9.66573 9.99171 9.64081 10.2907 9.74048 10.5897C9.4664 10.7641 9.16741 10.8887 8.84351 10.9634C8.71893 10.6644 8.49469 10.4651 8.22061 10.4651C7.97145 10.4651 7.74721 10.6644 7.59772 10.9634C7.27381 10.8887 6.97482 10.7641 6.70075 10.5897C6.82533 10.2907 6.80041 9.99171 6.60108 9.8173C6.42667 9.64289 6.12768 9.61797 5.82869 9.74255C5.65428 9.46848 5.5297 9.16949 5.45496 8.84558C5.75395 8.721 5.95327 8.49676 5.95327 8.22269C5.95327 7.97353 5.75395 7.74929 5.45496 7.59979C5.5297 7.27589 5.65428 6.9769 5.82869 6.70282C6.12768 6.8274 6.42667 6.80249 6.60108 6.60316C6.77549 6.42875 6.80041 6.12976 6.70075 5.83077C6.97482 5.65636 7.27381 5.53178 7.59772 5.45703C7.7223 5.75602 7.94654 5.95535 8.22061 5.95535C8.46977 5.95535 8.69401 5.75602 8.84351 5.45703C9.16741 5.53178 9.4664 5.65636 9.74048 5.83077C9.6159 6.12976 9.64081 6.42875 9.84014 6.60316C10.0146 6.77757 10.3135 6.80249 10.6125 6.70282C10.7869 6.9769 10.9115 7.27589 10.9863 7.59979C10.6873 7.72437 10.488 7.94861 10.488 8.22269C10.488 8.47185 10.6873 8.69609 10.9863 8.84558Z",
    stroke: "#BD1D23",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8323_7733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkingMonitoringLeftMenu);
export default __webpack_public_path__ + "static/media/networkingMonitoringLeftMenu.99da973727f0b1e0c148e6d268a674d2.svg";
export { ForwardRef as ReactComponent };